<template>
	<v-container>
		<v-layout 
			wrap
			align-center 
			justify-center
			stlye="max-heigh: 30%;"
		>
			<v-icon
				size="50"
				color="white"
			>
				fas fa-id-card
			</v-icon>
			<v-form
				ref="form"
				lazy-validation
			>
				<v-layout 
					row
					align-center 
					justify-center
					fill-height
				>
					<v-flex 
						justify-center
						xs3
					>
						<img
							v-if="photo"
							:src="imageUrl"
							class="document-preview"
						>
						<img 
							v-else
							src="@/assets/upload-placeholder.png"
							class="document-preview"
						>
					</v-flex>
					<v-spacer />
					<v-flex
						xs8
					>
						<v-layout
							justify-start
							fill-height
						>
							<v-btn
								color="orange lighten-1"
								class="upload-button"
								@click="onPickPhoto"
							>
								Upload a photo of you
								<v-icon right dark>
									fas fa-camera
								</v-icon>
							</v-btn>
							<input
								ref="photoFileInput"
								type="file"
								style="display: none"
								accept="image/*"
								@change="(event) => onPhotoPicked (event, 'photo')"
							>
						</v-layout>
					</v-flex>
				</v-layout>

				<v-layout
					row
					align-center 
					justify-center
					fill-height
				>
					<v-flex 
						justify-center
						xs3
					>
						<img
							v-if="idcard"
							:src="idcardUrl"
							class="document-preview"
						>
						<img 
							v-else
							src="@/assets/upload-placeholder.png"
							class="document-preview"
						>
					</v-flex>
					<v-spacer />
					<v-flex
						xs8
					>
						<v-layout
							justify-start
							fill-height
						>
							<v-btn
								class="upload-button"
								color="orange lighten-1"
								@click="onPickID"
							>
								Upload a valid ID or Passport
								<v-icon right dark>
									fas fa-id-card-alt
								</v-icon>
							</v-btn>
							<input
								ref="idFileInput"
								type="file"
								style="display: none"
								@change="(event) => onPhotoPicked (event, 'id')"
							>
						</v-layout>
					</v-flex>
				</v-layout>

				<v-layout 
					row
					align-center 
					justify-center
					fill-height
				>
					<v-flex 
						xs3
					>
						<img
							v-if="bill"
							:src="billUrl"
							class="document-preview"
						>
						<img 
							v-else
							src="@/assets/upload-placeholder.png"
							class="document-preview"
						>
					</v-flex>
					<v-spacer />
					<v-flex
						xs8
					>
						<v-layout
							justify-start
							fill-height
						>
							<v-btn
								class="upload-button"
								color="orange lighten-1"
								@click="onPickBill"
							>
								Upload a bill of your own
								<v-icon right dark>
									fas fa-file-invoice-dollar
								</v-icon>
							</v-btn>
							<input
								ref="billFileInput"
								type="file"
								style="display: none"
								@change="(event) => onPhotoPicked (event, 'bill')"
							>
						</v-layout>
					</v-flex>
				</v-layout>
			</v-form>
		</v-layout>
	</v-container>
</template>


<script>
import { mapMutations, mapActions, mapGetters } from 'vuex'

export default {

	props: ['credentials'],

	data () {
		return {
			alertLabel: '',
			title: 'Image Upload',
			dialog: false,
			imageUrl: '',
			idcardUrl: '',
			billUrl: '',
			photo: null,
			idcard: null,
			bill: null,
			valid:true
		}
	},

	computed: {
		color () {
			return ['error', 'warning', 'success'][Math.floor (this.progress / 40)]
		},
	},

	watch: {
	
	},

	methods: {
		onPickPhoto () {
			this.$refs.photoFileInput.click ()
		},

		onPickID () {
			this.$refs.idFileInput.click ()
		},

		onPickBill () {
			this.$refs.billFileInput.click ()
		},

		onPhotoPicked (event, type) {

			console.log (type)

			const files = event.target.files
			let fileName = files[0].name

			// Check the extension of the file
			if ( fileName.lastIndexOf ('.') <= 0) {
				return alert ('Attenzione il file selezionato non è valido')
			}

			// Convert the file to base64
			const fileReader = new FileReader ()
			fileReader.addEventListener ('load', () => {

				switch (type) {
				case 'id':
					this.idcardUrl = fileReader.result
					break
				case 'photo':
					this.imageUrl = fileReader.result
					break
				case 'bill':
					this.billUrl = fileReader.result
					break
				default:
					console.log ('Type error')
					return
				}
				
			})
			fileReader.readAsDataURL (files[0])

			switch (type) {
			case 'id':
				this.idcard = files[0]
				this.credentials.userDocument = this.idcard
				break
			case 'photo':
				this.photo = files[0]
				this.credentials.userPhoto = this.photo
				break
			case 'bill':
				this.bill = files[0]
				this.credentials.userInvoice = this.bill
				break
			default:
				console.log ('Type error')
				return
			}
		}
	}

}
</script>

<style lang="scss" scoped>
@import '@/styles/index.scss';

.title {
	color: $primary !important;
	text-transform: uppercase;
	font-size: 22px !important;
	font-weight: 400;
	margin: 10%;
}

.login-field {
	border-radius: 100px;
}

.sign-button {
	color: $primary;
	margin-left: 1%;
	font-size: 16px;
	text-transform: uppercase;
}

.sign-button:hover {
	text-decoration: underline;
}

.sign-disclaimer {
	font-size: 16px;
	color: rgba(0, 0, 0, 0.8);

}

.sign-in-container {
	margin-top: 5% !important;
}

.document-preview {
	max-width: 100%;
}

.upload-button {
	width: 100%;
}
</style>
